import { render, staticRenderFns } from "./romaKingdom.vue?vue&type=template&id=2d8b2e5a&scoped=true"
import script from "./romaKingdom.vue?vue&type=script&lang=js"
export * from "./romaKingdom.vue?vue&type=script&lang=js"
import style0 from "./romaKingdom.vue?vue&type=style&index=0&id=2d8b2e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b2e5a",
  null
  
)

export default component.exports